import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const compositeRuleValidationRuleResolver =
  (resolveSubRule: BaseValidationRuleResolver): BaseValidationRuleResolver =>
  (value, rule, prop, path, context) => {
    for (const subRule of rule.rules) {
      const errorMessage = resolveSubRule(value, subRule, prop, path, context);
      if (errorMessage !== null) {
        return errorMessage;
      }
    }
    return null;
  };
